/**
 * CollectionPills — horizontally-scrollable collection filter pills.
 * theme="dark" (default): active = red fill; inactive = translucent white.
 * theme="light": active = carbon fill; inactive = white + hairline (SimpleGallery).
 * Each pill shows a Space Mono count.
 */
const CollectionPills = ({
  collections = [],
  activeSlug = null,
  onSelect,
  totalCount = 0,
  totalLabel = 'All',
  theme = 'dark',
}) => {
  if (!collections || collections.length === 0) return null;

  const styleFor = (active) => {
    if (theme === 'light') {
      return active
        ? { background: '#141414', color: '#fff', border: '1px solid #141414' }
        : { background: '#fff', color: '#55555C', border: '1px solid #E2DED6' };
    }
    return active
      ? { background: '#BF212F', color: '#fff', border: '1px solid #BF212F' }
      : { background: 'rgba(255,255,255,0.07)', color: '#cfcdc9', border: '1px solid rgba(255,255,255,0.12)' };
  };

  const Pill = ({ active, name, count, onClick }) => (
    <button
      onClick={onClick}
      className="font-tiq-heading inline-flex items-center gap-2 whitespace-nowrap flex-shrink-0"
      style={{
        padding: '9px 15px',
        borderRadius: 999,
        fontWeight: 600,
        fontSize: 13,
        cursor: 'pointer',
        transition: 'all 0.25s var(--tiq-ease)',
        ...styleFor(active),
      }}
    >
      {name}
      <span className="font-tiq-mono" style={{ fontSize: 11, opacity: 0.7 }}>
        {count}
      </span>
    </button>
  );

  return (
    <div className="tiq-scroll flex gap-2 overflow-x-auto flex-1 min-w-0" style={{ paddingBottom: 2 }}>
      <Pill active={activeSlug === null} name={totalLabel} count={totalCount} onClick={() => onSelect(null)} />
      {collections.map((c) => (
        <Pill
          key={c.id || c.slug}
          active={activeSlug === c.slug}
          name={c.name}
          count={c.photo_count || 0}
          onClick={() => onSelect(c.slug)}
        />
      ))}
    </div>
  );
};

export default CollectionPills;
